export enum UpdateExperimentSettingsFormFieldNames {
  EXPERIMENT_ID = 'experimentId',
  EVENLY_SPLIT_VARIATIONS = 'evenlySplitVariations',
  CONVERSION_EVENT_TYPE = 'conversionEventType',
  HAS_HOLDOUT_GROUP = 'hasHoldOutGroup',
  HOLDOUT_GROUP_SIZE = 'holdOutGroupSize',
  ATTRIBUTION_PERIOD_HOURS = 'attributionPeriodHours',
  SEND_TIME_USE_REC_TIME = 'sendTimeUseRecipientTimeZones',
  TEST_DURATION_HOURS = 'testDurationHours',
  TEST_DURATION_MINUTES = 'testDurationMinutes',
  HOLDOUT_TEST_SIZE_PERCENTAGE = 'testSizePercentage',
  WINNING_CRITERIA_NAME = 'winningCriteriaName',
  SEND_TIME_START_TIME_ZONE = 'sendTimeStartTimeZone',
  SEND_TIME_USE_RECIPIENT_TIME_ZONE = 'sendTimeUseRecipientTimeZones',
  TEST_SENDS_PER_VARIATION = 'testSendsPerVariation',
  TRIGGERED_TEST_STRATEGY = 'triggeredTestStrategy',
  TEST_STRATEGY = 'testStrategy',
}
